class ProductQuickView extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      description: '.js-qv-product-description'
    }

    this.qvATC = this.querySelector('.qv-add-to-cart');

    this.qvDrawer = null;
    this.boundOpenHandler = this.openHandler.bind(this);
    this.boundKeydownHandler = this.handleKeyDown.bind(this);
    this.boundOutsideClickHandler = this.handleOutsideClick.bind(this);
    this.contentWrapper = this.querySelector('.product-qv-content-wrapper');
    this.qvToggles = null;


    //init form after qv loads
    this.form = null;
    this.aiSearchId;
    this.productHandle;

    this._modalStatePushed = false;

    //init analytics service
    this.INTER_URL = `${window.theme.apiUrl}/api/ai/search/analytics/interaction`;
    this.IMP_URL = `${window.theme.apiUrl}/api/ai/search/analytics/impression`;

    this.analyticsService = new window.AnalyticsService({
        impressionUrl: this.IMP_URL,
        interactionUrl: this.INTER_URL,
        idleMs: 15000,
        currency: window.theme?.currency || 'USD'
    });

  }


  connectedCallback() {
    this.qvDrawer = this.querySelector(".product-qv-drawer-wrapper");
    
    this.qvDrawer.addEventListener('click', this.trackATC.bind(this));

    // Global event listeners
    document.addEventListener("click", this.boundOpenHandler);
    document.addEventListener("keydown", this.boundKeydownHandler);
    document.addEventListener("click", this.boundOutsideClickHandler);

    // Back button / swipe back
    window.addEventListener('popstate', this.handleMobileBack.bind(this));

    
  }

  disconnectedCallback() {

    this.qvDrawer.removeEventListener('click', this.trackATC.bind(this));
    document.removeEventListener("click", this.boundOpenHandler);
    document.removeEventListener("keydown", this.boundKeydownHandler);
    document.removeEventListener("click", this.boundOutsideClickHandler);
  }

  handleMobileBack(e) {
    // If the drawer is open, close it instead of leaving the page
    if (this.qvDrawer.classList.contains('open')) {
      // Prevent loops: we're already in a pop caused by back
      this.closeModal({ fromPopstate: true });
    }
  }

  initAccordions() {

    this.qvToggles = this.querySelectorAll('.js-qv-accordion-toggle');
    this._onClick = this.handleAccordionClick.bind(this);

    // delegate to this component (use capture/passive as needed)
    this.addEventListener('click', this._onClick);
    
    // track panels currently animating to ignore re-clicks
    this._animating = new WeakSet();
  }

  initFancyBox(){

    const $supFacts = $('.js-qv-supplements-facts');
    const imgUrl = $(this).data('src');
    $supFacts.zoom({
      on: "click",
      magnify: 0.5,
      url: imgUrl
    });

  }


  handleAccordionClick(e) {
    const toggle = e.target.closest('.js-qv-accordion-toggle');
    if (!toggle || !this.contains(toggle)) return;

    const parent = toggle.closest('.js-qv-accordion-tab');
    if (!parent) return;
    const content = parent.querySelector('.js-qv-accordion-tab-content');
    if (!content) return;

    // 2) ignore clicks while this panel is animating
    if (this._animating.has(content)) return;
    this._animating.add(content);
    toggle.classList.add('is-busy');               // optional: visual/UX lock

    parent.classList.toggle('open');

    const done = () => {
      this._animating.delete(content);
      toggle.classList.remove('is-busy');
    };

    // Works whether your slideToggle returns a Promise or not
    const maybePromise = slideToggle(content);
    if (maybePromise && typeof maybePromise.finally === 'function') {
      maybePromise.finally(done);
    } else {
      // Fallback: clear lock on transition end (and a timeout safety net)
      const cleanup = () => {
        content.removeEventListener('transitionend', cleanup);
        done();
      };
      content.addEventListener('transitionend', cleanup, { once: true });
      setTimeout(done, 500); // safety in case transitionend doesn't fire
    }
  }

  trackATC(event){
    
    console.log('ATC Event', event.target);
    if (!event.target.closest('.qv-add-to-cart')) return;
    console.log('track atc')

    if (this.analyticsService && this.analyticsService.getSearchId()) {
      const price = this.querySelector('.product__price-container [data-product-price]').dataset.productPrice;
      this.analyticsService.trackAddToCart(this.productHandle, 1, price)
    }

    //close modal
    this.closeModal();
  }

  resetAnalyticsService() {
    if (this.analyticsService) {
      //reset impressions
      this.analyticsService.resetImpressions();
      this.analyticsService.setSearchId(null);
    }
      
  }

  openHandler(e) {
    const trigger = e.target.closest(".js-open-qv");
    const closeTrigger = e.target.closest(".product-qv-close, .qv-add-to-cart");
    

    if (trigger) {
      e.preventDefault();
      const aiQuery = trigger.dataset.aiQuery ?? false;
      this.aiSearchId = trigger.dataset.aiSearchId ?? false;
      this.productHandle = trigger.dataset.handle;
      
      this.openModal(this.productHandle, aiQuery);

      if (this.aiSearchId && this.analyticsService) {
        
        this.analyticsService.setSearchId(this.aiSearchId);
        console.log("Product QV set SearchID: ", this.aiSearchId);
      }

      
      

      // Push a history state once per open
      if (!this._modalStatePushed) {
        console.log('qv pushed state');
        //pushStateMerge({ qv: { open: true } });
        history.pushState({ ...(history.state||{}), qv: { open: true } }, '');
        this._modalStatePushed = true;
      }
      
    } else if (closeTrigger) {
      this.closeModal();
    }
  }



  handleOutsideClick(e) {
    if (
      this.qvDrawer.classList.contains("open") &&
      !e.target.closest(".product-qv-drawer")
    ) {
      this.closeModal();
    }
  }

  handleKeyDown(e) {
    if (e.key === "Escape" && this.qvDrawer.classList.contains("open")) {
      this.closeModal();
    }
  }

  async openModal(handle, aiQuery = false) {


    //get ai query -- fetch simultaneously
    let fetchAiAnswer = null;
    if (aiQuery) {

      const data = {
        handle: handle,
        searchId: this.aiSearchId || ""
      }

      fetchAiAnswer = fetch(`${window.theme.apiUrl}/api/ai/search/analytics/productAnswer`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
    }

    await fetch(`${window.Shopify.routes.root}products/${handle}?view=qv`)
      .then((res) => res.text())
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;
        const content = temp.querySelector(".product-qv-content-container");

        if (content) {
          const wrapper = this.qvDrawer.querySelector(".product-qv-content-wrapper");
          wrapper.innerHTML = "";
          wrapper.appendChild(content);

          //init form
          this.form = this.querySelector('.js-qv-product-form');

          if (aiQuery) {
            const descriptionElement = this.querySelector(this.selectors.description);
            const description = descriptionElement.innerHTML;

            descriptionElement.classList.add('loading');

            //clear description element. to prepare for the ai content
            descriptionElement.innerHTML = "";

            //copy description to alt description container
            const altDescription = this.querySelector('.js-qv-alternate-description-container');
            altDescription.innerHTML = description;
            altDescription.classList.add('active');

            //hide label 2 container
            //this.querySelector('.js-qv-product-upsell-wrapper').style.display = "none";

            //add skeleton loading
            descriptionElement.innerHTML =
            `<div class="skeleton-description">
              <div class="skeleton-line short"></div>
              <div class="skeleton-line"></div>
              <div class="skeleton-line"></div>
              <div class="skeleton-line"></div>
            </div>`


            //add hidden searchId property for analytics
            const input = document.createElement('input');
            input.id = 'aisearchid-input';
            input.type = 'hidden';
            input.name = 'properties[_aisearchid]';
            input.value = this.aiSearchId
            this.form.appendChild(input); 

            //append searchId to URL of product for tracking
            const link = document.querySelector('.js-product-qv-learn-more-btn');
            if (link) {
              const url = new URL(link.getAttribute('href'), window.location.origin);
              url.searchParams.set('searchId', this.aiSearchId);       // adds or updates
              link.setAttribute('href', url.pathname + url.search + url.hash);
            }
            
          }

          this.initCarousel();

          this.initAccordions();

          this.initFancyBox();

          document.documentElement.classList.add("qv--open");
          document.body.classList.add("qv--open");
          this.qvDrawer.classList.add("open");

          if (this.analyticsService && this.analyticsService.getSearchId()) {
            this.analyticsService.startView(this.productHandle)
          } 
        }

        
        //delay disbable body scroll lock so they don't see the jump on IOS
        setTimeout(function () {
          bodyScrollLock.disableBodyScroll(this.contentWrapper);
        }, 500)
        
      })
      .catch(() => {
        console.warn("QV failed, redirecting");
        window.location.href = `${window.Shopify.routes.root}products/${handle}`;
      });
    
    //handle aiquery if exists
    if (aiQuery) {
      fetchAiAnswer
        .then((res) => res.json())
        .then((response) => {
          const answer = response.answer;
          const descriptionElement = this.querySelector(this.selectors.description);
          
          //append answer to description element. Append asterisk at the end
          descriptionElement.innerHTML = `<b class="ai-description-prefix"><i>${window.theme.strings.qv.ai.descriptionPrefix}</i></b> ${answer}*`;
          descriptionElement.classList.remove('loading');

          this.querySelector('.js-qv-product-description-container').classList.add('has-ai-content');
        })
        .catch( err => {
          console.log(err);
          descriptionElement.innerHTML = ``;
          descriptionElement.classList.remove('loading');
        })
    }
  }


  /*
  handleAIContent(aiContentSelector) {
    const aiContent = document.querySelector(aiContentSelector);

    if (!aiContent) return;

    const descriptionElement = this.querySelector('.js-qv-product-description');
    const description = descriptionElement.innerHTML;

    //copy description to alt description container
    const altDescription = this.querySelector('.js-qv-alternate-description-container');
    altDescription.innerHTML = description;
    altDescription.classList.add('active');

    //add ai content to the description element
    descriptionElement.innerHTML = aiContent.innerHTML;

    //hide label 2 container
    this.querySelector('.js-qv-product-upsell-wrapper').style.display = "none";

    this.querySelector('.js-qv-product-description-container').classList.add('has-ai-content');
  }
  */

  closeModal(opts = {}) {
    this.qvDrawer.classList.add("closing");
    setTimeout(() => {
      this.qvDrawer.classList.remove("open", "closing");
    }, 400);
    document.documentElement.classList.remove("qv--open");
    document.body.classList.remove("qv--open");

    bodyScrollLock.enableBodyScroll(this.contentWrapper);

    //stop tracking if there is search element
    if (this.analyticsService && this.analyticsService.getSearchId()) {
      this.analyticsService.stopView(this.productHandle);
    } 

    this.resetAnalyticsService();
    
    // If we *initiated* the close (Escape, click X, etc.), pop the history
    if (this._modalStatePushed && !opts.fromPopstate) {
      console.log('modal state pushed');
      // This will trigger the popstate listener, so guard with the flag
      this._modalStatePushed = false; // reset before calling back
      
      return;
    }

    // If we arrived here via popstate, just reset the flag
    this._modalStatePushed = false;
          
  }

  initCarousel() {
    const carousel = this.qvDrawer.querySelector(".js-flickity-carousel");
    if (carousel && !carousel.classList.contains("is-initialized")) {
      const flkty = new Flickity(carousel, {
        imagesLoaded: true,
        wrapAround: true,
        pageDots: false,
        lazyLoad: true,
        contain: true,
        cellAlign: "left",
        prevNextButtons: false
      });

      const prev = this.qvDrawer.querySelector(".flickity-prev");
      const next = this.qvDrawer.querySelector(".flickity-next");

      if (prev && next) {
        prev.addEventListener("click", () => flkty.previous());
        next.addEventListener("click", () => flkty.next());
      }

      carousel.classList.add("is-initialized");
    }
  }
}

customElements.define("product-quickview", ProductQuickView);
